export const config = {
  //apiUrl: 'http://localhost:8080',
  apiUrl: '/api',
  captchaKey: '6LckkBcmAAAAAJnEe3d7NiokEIvJQt2aVql41sk0',
  captchaLoadAfter : 3,
  defaultPagingRating : 10,
  maxLimitItemShow : 2,
  secretKey: '7JtwZkSeavRLItKKg96XuJyzE'
};
